import axios, { getVariable } from "./api";
import { globalLoading, closeGlobalLoading } from "./loading";
import { keycloak } from "../components/auth";

export const getStatus = async (usuario) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.get(
    (await getVariable("CONHECIGAME_API")) + "/respostas/" + usuario,
    headers
  );
};

export const getCorretAnswers = async (user_id, theme_id, match_id) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.get(
    (await getVariable("CONHECIGAME_API")) +
      "/respostas/" +
      user_id +
      "/" +
      theme_id +
      "/" +
      match_id,
    headers
  );
};

export const setResposta = async (respostadata) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  globalLoading("Salvando dados da resposta...");

  if (!window.OFFLINE.isOffline) {
    return axios
      .post(
        (await getVariable("CONHECIGAME_API")) + "/setmatchanswer",
        respostadata,
        headers
      )
      .then((data) => {
        closeGlobalLoading();
        return data;
      })
      .catch(() => {
        closeGlobalLoading();
      });
  } else {
    window.OFFLINE.stack.push({
      action: "setResposta",
      params: respostadata,
    });

    localStorage.setItem("OFFLINE_STACK", JSON.stringify(window.OFFLINE.stack));
  }
};
